import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=aece70a6&scoped=true"
import script from "./Remind.vue?vue&type=script&lang=js"
export * from "./Remind.vue?vue&type=script&lang=js"
import style0 from "./Remind.vue?vue&type=style&index=0&id=aece70a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aece70a6",
  null
  
)

export default component.exports